import { useEffect, useState } from "react";

// Edición inline del monto de una jugada: commit reactivo solo con valores válidos (>0).
export const SlipAmountInput = ({ value, onCommit, prefix, className = "", testId }) => {
  const [draft, setDraft] = useState(String(value));
  const [focused, setFocused] = useState(false);

  useEffect(() => { if (!focused) setDraft(String(value)); }, [value, focused]);

  const n = parseFloat(draft);
  const invalid = !(Number.isFinite(n) && n > 0);

  const handleChange = (e) => {
    const raw = e.target.value.replace(",", ".");
    if (!/^\d*\.?\d{0,2}$/.test(raw)) return;
    setDraft(raw);
    const v = parseFloat(raw);
    if (Number.isFinite(v) && v > 0) onCommit(v);
  };

  return (
    <label className="inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      <span className={`text-xs font-bold ${className}`}>{prefix}</span>
      <input
        type="text"
        inputMode="decimal"
        value={draft}
        onChange={handleChange}
        onFocus={(e) => { setFocused(true); e.target.select(); }}
        onMouseUp={(e) => e.preventDefault()}
        onBlur={() => { setFocused(false); setDraft(String(value)); }}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === "Escape") e.currentTarget.blur(); }}
        className={`w-24 rounded-md border-2 bg-background/60 px-2 py-1 text-right font-mono tabular-nums text-sm font-bold outline-none transition-colors focus:ring-2 focus:ring-primary/50 ${invalid ? "border-amber-500" : "border-border focus:border-primary"} ${className}`}
        aria-invalid={invalid}
        data-testid={testId}
      />
    </label>
  );
};
